module.exports = __webpack_public_path__ + "img/provider-desktop.679f09e1.svg";